import useRoute from "../hooks/useRoute";
import { resetQSToDefault, updateQSAndApply } from "../helpers/url-helper";
import { useHistory } from "react-router-dom";

export default function useSyncFilterWithParam() {
  let history = useHistory();
  let route = useRoute();
  let params = route.params || {};

  function setParam(param: { name: string; value: string }) {
    updateQSAndApply(param, history);
  }

  function reset(param: string) {
    resetQSToDefault(history, param);
  }

  return { params, setParam, reset };
}
